import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const ApprovedContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  wordBreak: "break-word",
  overflowWrap: "break-word",
  [theme.breakpoints.down("sm")]: {
    padding: "0",
    "& p, & span, & h1, & h2, & h3, & h4, & h5, & h6, & div": {
      wordBreak: "break-word",
      overflowWrap: "break-word",
    },
  },
}));

export const ApprovedIcon = styled(Box)(({ theme }) => ({
  marginBottom: "60px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    marginBottom: "24px",
  },
}));

export const ApprovedTitle = styled(Typography)(({ theme }) => ({
  fontSize: "26px",
  fontStyle: "normal",
  fontWeight: 600,
  textAlign: "center",
  marginBottom: "12px",
  color: "#1B252F",
  lineHeight: "36px",
  whiteSpace: "pre-line",
  [theme.breakpoints.down("sm")]: {
    fontSize: "18px",
    lineHeight: "26px",
    marginBottom: "12px",
  },
}));

export const ApprovedSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontFamily: "Nunito",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "28px",
  maxWidth: "600px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
    lineHeight: "22px",
    maxWidth: "100%",
  },
}));

export const ApprovedActions = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));
